import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import onClickOutside from 'react-click-outside';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { REDUCER_NAME, toggleActiveQuickComponent } from '../../reducer';

class QuickAccessPopup extends PureComponent {
  handleClickOutside = e => {
    const { showRef } = this.props;
    if (showRef && showRef.current && showRef.current.contains(e.target)) {
      return;
    }
    const { showPopup } = this.props;
    showPopup(false);
  };

  onCheckboxChange = (componentName, isActive) => {
    const { toggleActiveQuickComponent } = this.props;
    toggleActiveQuickComponent(componentName, isActive);
  };

  render() {
    const { quickComponents } = this.props;
    return (
      <div className="quick-access-popup">
        <div className="quick-access-popup-title">
          {I18n.t('layout.quickAccessComponentTitle')}
        </div>

        <div className="component-list">
          {quickComponents.map(({ componentName, isActive }) => (
            <div key={componentName} className="checkbox position-relative">
              <input
                className="custom-checkbox d-none"
                id={`cb-${componentName}`}
                type="checkbox"
                checked={isActive}
                onChange={() => this.onCheckboxChange(componentName, isActive)}
              />
              <label htmlFor={`cb-${componentName}`}>
                {I18n.t(`layout.quickAccess.${componentName}`)}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

QuickAccessPopup.propTypes = {
  quickComponents: PropTypes.array.isRequired,
  toggleActiveQuickComponent: PropTypes.func.isRequired,
  showPopup: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  quickComponents: state[REDUCER_NAME].quickComponents,
});

const mapDispatchToProps = {
  toggleActiveQuickComponent,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  onClickOutside,
)(QuickAccessPopup);
